import React, { Component } from "react";
import { withFirebase } from "../../components/Firebase/Firebase";
import { withPrismic } from "../../components/Prismic/Prismic";
import RichText from "../../components/RichText/RichText";
import Button from "../../components/Button/Button";


class CompetitionStageOpen extends Component {
	
	render() {

		if(!this.props.terms) return null;

		const slug = this.props.competitions[this.props.competitionId].url;

		return (
			<div>
				<RichText content={this.props.terms.state_applications_open} />
				{slug === 'testcomp2019' || true // switch for testing purposes
					? (<div>
						<Button to={`/competition/${slug}/enter`} type="secondary">Let's Do It</Button>
					</div>)
					: null
				}
				<RichText content={this.props.terms.state_application_open_suffix} />
			</div>
		);
	}
}

export default withPrismic(withFirebase(CompetitionStageOpen));



// WEBPACK FOOTER //
// ./src/pages/Competition/CompetitionStageOpen.js